import { render, staticRenderFns } from "./routePage.vue?vue&type=template&id=4ad05988&scoped=true&"
import script from "./routePage.vue?vue&type=script&lang=ts&"
export * from "./routePage.vue?vue&type=script&lang=ts&"
import style0 from "./routePage.vue?vue&type=style&index=0&id=4ad05988&prod&lang=css&"
import style1 from "./routePage.vue?vue&type=style&index=1&id=4ad05988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad05988",
  null
  
)

export default component.exports